import React from "react";
import { NMPopup, Col } from "@neumetric/blueprint-lib/components";
import { riskActions } from "../../store";
import { useDispatch } from "react-redux";

export const ExportRiskDialog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const [submitting, setSubmitting] = React.useState(false);
  const handleConfirm = () => {
    setSubmitting(true);
    const action = riskActions.exportOrgRisks();
    action.onComplete = () => {
      setSubmitting(false);
      onClose();
    };
    action.onFailure = () => {
      setSubmitting(false);
    };
    dispatch(action);
  };
  return (
    <NMPopup
      variant="INFO"
      title="Export Risks?"
      visible={open}
      actions={[
        {
          label: "Cancel",
          btnType: "OUTLINED",
          onClick: onClose,
          icon: "CANCEL",
          disabled: submitting,
        },
        {
          label: "Export",
          btnType: "CONTAINED",
          variant: "ACTION",
          onClick: handleConfirm,
          icon: "DOWNLOAD",
          loading: submitting,
        },
      ]}
    >
      <Col className="w-100 ff-roboto fs-15 fw-400 text-filled line-auto">
        <span>Risks will be exported as CSV.</span>
      </Col>
    </NMPopup>
  );
};
